import { DefaultConfig } from "@/shared/lib/threejs/config/default.config";
import { glyxConfig } from "@/shared/lib/threejs/config/glyx.config";
// import { golgolzConfig } from "@/shared/lib/threejs/config/golgolz.config";
import { kikizConfig } from "@/shared/lib/threejs/config/kikiz.config";
import { nalnaniConfig, nalnaniKioskConfig } from "@/shared/lib/threejs/config/nalnani.config";
import { vroidConfig } from "@/shared/lib/threejs/config/vroid.config";
import { bambamConfig } from "@/shared/lib/threejs/config/bambam.config";
import { gangwhaConfig } from "@/shared/lib/threejs/config/gangwha.config";
import { bobbiConfig } from "@/shared/lib/threejs/config/bobbi.config";
import { taekwondoConfig } from "@/shared/lib/threejs/config/taekwondo.config";
import {
  createCustomAvatarThreeConfig,
  createCustomAvatarThreeConfigWithScenarios,
  type CustomAvatarData,
  type CustomAvatarDataWithScenarios,
} from "@/shared/lib/threejs/config/custom-avatar.config";

export type AvatarType = 'glyx' | 'nalnani' | 'kikiz' | 'bambam' | 'vroid' | 'goesan' | 'gangwha' | 'bobbi' | 'taekwondo' | 'custom';

// 커스텀 아바타 데이터를 저장할 변수 (런타임에 설정됨)
// 시나리오 설정이 포함된 확장 타입 지원
let currentCustomAvatarData: CustomAvatarData | CustomAvatarDataWithScenarios | null = null;

/**
 * 커스텀 아바타 데이터 설정
 * 커스텀 아바타를 로드하기 전에 호출해야 합니다.
 */
export const setCustomAvatarData = (data: CustomAvatarData | CustomAvatarDataWithScenarios | null): void => {
  console.log('🔧 [CONFIG] setCustomAvatarData 호출됨:', data?.id, data?.modelUrl);
  currentCustomAvatarData = data;
};

/**
 * 현재 커스텀 아바타 데이터 조회
 */
export const getCustomAvatarData = (): CustomAvatarData | CustomAvatarDataWithScenarios | null => {
  console.log('🔧 [CONFIG] getCustomAvatarData 호출됨:', currentCustomAvatarData?.id, currentCustomAvatarData?.modelUrl);
  return currentCustomAvatarData;
};

export type DisplayMode = 'web' | 'kiosk';

export const getThreeJsConfig = (avatarType: AvatarType, mode: DisplayMode = 'web'): DefaultConfig => {
  switch (avatarType) {
    case 'glyx':
      return glyxConfig;
    case 'nalnani':
      return mode === 'kiosk' ? nalnaniKioskConfig : nalnaniConfig;
    case 'kikiz':
      return kikizConfig;
    case 'bambam':
      return bambamConfig;
    // case 'golgolz':
    //   return golgolzConfig;
    case 'vroid':
      return vroidConfig;
    case 'gangwha':
      return gangwhaConfig;
    case 'bobbi':
      return bobbiConfig;
    case 'taekwondo':
      return taekwondoConfig;
    case 'custom':
      if (currentCustomAvatarData) {
        // 상세 로깅
        console.log('🔧 [CONFIG] currentCustomAvatarData:', {
          id: currentCustomAvatarData.id,
          hasScenarioConfigs: 'scenarioConfigs' in currentCustomAvatarData,
          scenarioConfigsLength:
            'scenarioConfigs' in currentCustomAvatarData
              ? (currentCustomAvatarData as CustomAvatarDataWithScenarios).scenarioConfigs?.length
              : 0,
        });

        // 시나리오 설정이 있으면 WithScenarios 버전 사용
        if ('scenarioConfigs' in currentCustomAvatarData && currentCustomAvatarData.scenarioConfigs?.length) {
          console.log('🔧 [CONFIG] 시나리오 설정 기반 config 생성:', currentCustomAvatarData.scenarioConfigs.length, '개');
          return createCustomAvatarThreeConfigWithScenarios(currentCustomAvatarData as CustomAvatarDataWithScenarios);
        }

        console.warn('🔧 [CONFIG] 레거시 config 생성 (시나리오 설정 없음)');
        return createCustomAvatarThreeConfig(currentCustomAvatarData);
      }
      console.warn('⚠️ 커스텀 아바타 데이터가 설정되지 않았습니다. 기본 설정을 사용합니다.');
      return nalnaniConfig;
    default:
      console.warn(`⚠️ 지원하지 않는 아바타 타입: ${avatarType}`);
      return nalnaniConfig;
  }
};